module.exports = __webpack_public_path__ + "img/1487568968.bd496d08.jpg";